import { modals } from '@mantine/modals';

import { useShowResponseStatus } from '@/shared';
import { useDeleteWithdrawalMethodMutation } from '../store/withdrawal-methods-api';

import type {
  // TWithdrawalMethodDeleteParams,
  TWithdrawalMethod,
} from '../store/types';

export const useDeleteWithdrawalMethod = () => {
  const [deleteWithdrawalMethod, {
    isLoading,
    isSuccess,
    isError
  }] = useDeleteWithdrawalMethodMutation();

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Метод вывода успешно удалён',
    isError,
    errorMassage: 'При удалении метода вывода произошла ошибка',
  });

  const openDeleteModal = (item: TWithdrawalMethod) => modals.openConfirmModal({
    title: `Удаление метода с ID ${item.id}`,
    centered: true,
    children: `Вы точно хотите удалить метод "${item.name}"?`,
    labels: { confirm: 'Удалить', cancel: 'Отмена' },
    confirmProps: { color: 'red' },
    onConfirm: async () => await deleteWithdrawalMethod({ methodId: item.id }),
  });

  return {
    isLoading,
    openDeleteModal,
  };
};
